<template>
    <form method='post' :action="url" id="vue-form">
        <input type="hidden" name="Ds_SignatureVersion" :value="version"/>
        <input type="hidden" name="Ds_MerchantParameters" :value="params"/>
        <input type="hidden" name="Ds_Signature" :value="signature"/>
    </form>
</template>

<script>
import { sum } from 'ramda';

const redsysUrl = window.groovie.redsys_url;
const succesUrl = window.groovie.redsys_success;
const failUrl = window.groovie.fail_url;

export default {
    name: 'paypal',
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            url: redsysUrl,
            version: '',
            params: '',
            signature: '',
            succes_url: succesUrl,
            fail_url: failUrl
        };
    },
    methods: {
        updateTotal() {
            const total = this.items.map(({ quantity, price }) => price * quantity);
            return sum(total);
        }
    },
    mounted() {
        this.$groovie
            .post('/api/v1/tpv', {
                type: 'redsys',
                total: this.updateTotal(),
                ok: this.succes_url,
                fail: this.fail_url
            })
            .then(({ version, params, signature }) => {
                this.version = version;
                this.params = params;
                this.signature = signature;
            })
            .catch(error => console.error(error));
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Redsys.vue